<template>
  <!-- 6年及以后基础费用 -->
  <div class="td">
    <Dropdown :visible="visible" trigger="custom" @mouseleave.native="closePreview" placement="left">
      <div class="btn" @mouseover="openPreview" @click="$emit('openModal')" >
        <span v-if="topItem.sourceType == 2">{{ tableItem.hasYear6 ? '已配置' : '配置' }}</span>
        <span v-else>{{ tableItem.hasYear6 ? '查看' : '-' }}</span>
      </div>
      <template slot="list">
        <div class="list-item" v-if="tableItem.hasYear6">
          <div class="tools-box">
            <span>第六年及以后基础费用(%)</span>
          </div>
          <div class="table">
            <div class="tr">
              <div class="td th">方案</div>
              <div class="td th" v-for="(bean) in indexList" :key="bean.id">
                <span>{{ bean.text }}</span>
              </div>
            </div>
            <div class="tr" v-for="item in tableItem.programBaseList" :key="item.id">
              <div class="td">{{ item.name || '-' }}</div>
              <div class="tr" v-for="(item2,i) in item.organizationList" :key="'i'+i">
                <div class="td" v-for="(item3,ii) in item2.commissionInfoBeans6" :key="'ii'+ii">
                  {{ item3.value ? item3.value : '-' }}
                </div>
              </div>
              
            </div>
          </div>
        </div>
        <template v-if="!tableItem.hasYear6">
          <div class="empty-item">未配置</div>
        </template>
      </template>
    </Dropdown>
  </div>
</template>
  
<script>
import common from './common.config.js';
export default {
  mixins: [common],
  components: {},
  props: {
    tableItem: null,
    topItem: null
  },
  data() {
    return {
      visible: false,
      list: [],
      indexList: []
    };
  },
  computed: {},
  created() {},
  methods: {
    initData() {
      let indexList;
      const untilLastCommissionIndex = this.topItem.untilLastCommissionIndex;// 交费期满的年限
      this.tableItem.programBaseList.forEach(item => {
        item.organizationList.forEach(item2 => {
          if (!indexList) {
            indexList = item2.commissionInfoBeans6;
          }
        });
      });
      this.indexList = indexList.map(item=>{
        const showLast = untilLastCommissionIndex == item.commissionIndex;// 是否显示至交费期满
        item.text = `第${this.$units.numberTransform(item.commissionIndex)}年${showLast?'至交费期满':''}(%)`;
        return item;
      });
      this.visible = true;
      console.log(this.tableItem);
    }
  }
};
</script>
<style lang="scss" scoped>
@import './itemCommon.scss';
.table {
  max-width: 700px;
  overflow-x: auto;
  .tr {
    .tr {
      border-left: 1px solid#E9E9E9;
    }
    .big-td {
      flex: 160px;
      min-width: 160px;
      span {
        margin-left: 0 !important ;
      }
    }
  }
}
</style>  